import React, { useState, useEffect, useCallback, useRef, createContext } from "react";
import { Routes, Route, Link, useLocation, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/main/Home";
import Account from "./pages/account/Account";
import PerformOrder from "./pages/perform_order/PerformOrder";
import NotFound from "./pages/errors/NotFound";
import TechBreak from "./pages/errors/TechBreak";
import Rules from "./pages/rules/Rules";
import ExternalAuth from "./pages/account/ExternalAuth";
import { Container, Box } from "@mui/material";
import { useSnackbar } from "notistack";
import REST from "./libs/API";
import { setDict, getText } from "./libs/utils";
import { withCookies } from "react-cookie";
import equal from "fast-deep-equal";
import { styled } from "@mui/material/styles";
import { Logo, CloseIcon } from "./assets/images/icons";
import RedirectToOrder from "./pages/main/RedirectToOrder";
import GlobalModal from "./components/GlobalModal";
import CommonKYC from "./pages/account/CommonKYC";
console.log('check updates');
const MyGreenScreen = styled(Box)(() => ({
  background: '#56C37C',
  position: 'absolute',
  height: '100%',
  minHeight: '100vh',
  width: '100%',
  top: 0,
  left: 0,
  zIndex: 10000,
  "svg": {
    position: 'absolute',
    width: '350px',
    height: '100px',
    top: '50vh',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  }
}))

export const UserDataContext = createContext({
  email: null,
  token: null,
  refCode: null,
  resetToken: null,
  auth: () => { },
  deAuth: () => { },
  hasKyc: null,
  setHasKyc: () => { },
});

function App({ cookies }) {
  const token = cookies.get('token');
  const email = cookies.get('email');
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [lang, setLang] = useState('');
  const [user, setUser] = useState({ token, email });
  const [siteStatus, setSiteStatus] = useState({});
  const [greenScreen, setGreenScreen] = useState(true);
  const { pathname } = useLocation();
  const previousPathRef = useRef(pathname);

  if (email !== user.email || token !== user.token) {
    setUser({ ...user, email, token });
  }

  const loadUrlData = () => {
    const qParams = new URLSearchParams(window.location.search);
    let userData = {};

    if (qParams.get("refCode")) {
      userData = { refCode: qParams.get("refCode") };
      cookies.set("refCode", qParams.get("refCode"), {
        path: "/",
        maxAge: 1800,
      });
    }

    if (qParams.get("resetToken")) {
      userData = { ...userData, resetToken: qParams.get("resetToken") };
    }

    if (qParams.get("activateToken")) {
      REST.activate(qParams.get("activateToken")).then((data) => {
        if (data && data.success) {
          window.showMessage(getText("userActivateSuccess"));
        }
      });
    }

    Object.keys(userData).length > 0 && setUser({ ...user, ...userData });
  };

  useEffect(() => {
    // Fetch the profile after authentication or on the initial page load.
    try {
      if (token) {
        REST.getProfileData(token).then(data => {
          if (data && data.success) {
            setHasKyc(data.data.hasKyc);
          } else {
            const stored = localStorage.getItem('hasKyc');
            if (stored !== null) {
              setUser(prev => ({ ...prev, hasKyc: stored === 'true' }));
            }
          }
        });
      } else {
        localStorage.removeItem('hasKyc');
        setUser(prev => ({ ...prev, hasKyc: undefined }));
      }
    } catch (e) { }
  }, [token]);

  useEffect(() => {
    const previousPath = previousPathRef.current;
    previousPathRef.current = pathname;

    // KYC providers return to the site without reloading the SPA. Refresh
    // only on that transition, not on every route change.
    if (token && previousPath === '/kyc-pass' && pathname !== '/kyc-pass') {
      REST.getProfileData(token).then(data => {
        if (data && data.success) {
          setHasKyc(data.data.hasKyc);
        }
      });
    }
  }, [token, pathname]);

  const setHasKyc = useCallback((hasKyc) => {
    setUser(prev => ({ ...prev, hasKyc }));
    try {
      localStorage.setItem('hasKyc', hasKyc ? 'true' : 'false');
    } catch (e) { }
  }, []);

  const loadDictionary = () => {
    REST.getDictionary().then((text) => {
      let parsed = text;
      if (parsed && parsed.data.length !== 0) {
        let TEXT;
        localStorage.TEXT = text;
        TEXT = parsed && parsed.data || {};
        TEXT = {
          ...TEXT
        }
        setDict(TEXT);
        setLang(localStorage.lang);
      } else {
        console.error("Ошибка загрузки словаря");
        localStorage.lang = "ru";
        setLang("ru");
        return false
      }
    });
  };

  const getSiteConfig = () => {
    const qParams = new URLSearchParams(window.location.search);
    let urlLink;
    let path = window.location.pathname;



    if (qParams.get('cur_from')) {
      urlLink = `${qParams.get('cur_from')}-${qParams.get('cur_to')}`
    } else {
      if (path.search("/deal/") === 0) {
        urlLink = path.split("/")[2]
      }
    }

    REST.getSiteStatus(urlLink).then((data) => {
      if (data && data.success) {

        data.data.infoMessages && showMessages(data.data.infoMessages);

        setSiteStatus({
          centRates: data.data.rates,
          workTimeout: data.data.technicalWorkTimeout,
          breakText: data.data.breakText,
          siteStatus: data.data.status.id,
          urlData: Array.isArray(data.data.exchangeAttributes) ? null : data.data.exchangeAttributes,
          infoMessages: data.data.infoMessages,
          exchangeCount: data.data.exchangeCount
        });
      } else {
        setSiteStatus({ siteStatus: 1 });
      }
    });
  };

  const getSiteStatus = () => {
    REST.getSiteStatus().then((data) => {
      if (data && data.success) {
        data.data.datetime = null;
        if (!equal(siteStatus.prevState, data.data)) {
          setSiteStatus({
            centRates: data.data.rates,
            workTimeout: data.data.technicalWorkTimeout,
            breakText: data.data.breakText,
            siteStatus: data.data.status.id,
            urlData: Array.isArray(data.data.exchangeAttributes) ? null : data.data.exchangeAttributes,
            infoMessages: data.data.infoMessages,
            exchangeCount: data.data.exchangeCount,
            prevState: data.data,
          });
        }
      } else {
        return false;
      }
    });
  };

  const showMessages = (message = []) => {
    if (cookies.get('disableMsg')) {
      return false;
    }

    message.map((msg) =>
      enqueueSnackbar(<Box sx={{ paddingRight: '10px' }}>
        {msg.message}
        <CloseIcon
          onClick={() => closeSnackbar()}
          style={{ position: "absolute", right: 10, top: 10, cursor: "pointer", }}
        />
      </Box>,
        {
          anchorOrigin: { horizontal: "left", vertical: "bottom" },
          autoHideDuration: null,
        }
      )
    );

  };

  const cookieUse = () => {
    if (!cookies.get('cookieUse')) {

      const cookieSnackKey = enqueueSnackbar(
        <Box sx={{ paddingRight: '10px' }}>
          {getText("weUseCookie01")}{" "}
          <Link to="/rules">{getText("weUseCookie02")}</Link>
          <CloseIcon
            onClick={closeCookieSnack}
            style={{ position: "absolute", right: 10, top: 10, cursor: "pointer", }}
          />
        </Box>,
        {
          anchorOrigin: { horizontal: "left", vertical: "bottom" },
          autoHideDuration: null,
        }
      );

      function closeCookieSnack() {
        closeSnackbar(cookieSnackKey);
        cookies.set("cookieUse", true, { path: "/" });
      }
    }
  };

  const auth = (token, email, remember = 0) => {
    cookies.set('token', token, {
      path: '/',
      maxAge: remember
        ? 86400 * 14
        : 1800,
    });
    cookies.set('email', email, {
      path: '/',
      maxAge: remember
        ? 86400 * 14
        : 1800,
    });
    setUser({ ...user, email, token })
  }

  const deAuth = () => {
    cookies.set('token', "", {
      path: '/',
      maxAge: 0,
    });
    cookies.set('mail', "", {
      path: '/',
      maxAge: 0,
    });
    setUser({ ...user, email: undefined, token: undefined, hasKyc: undefined });
    try { localStorage.removeItem('hasKyc'); } catch (e) { }
  };

  useEffect(() => {
    loadDictionary();
    loadUrlData();
    getSiteConfig();
    window.deAuth = deAuth;
    window.showMessage = (text) => {
      enqueueSnackbar(text, {
        anchorOrigin: { horizontal: "left", vertical: "bottom" },
      });
    };
  }, []);

  useEffect(() => {
    const checkSiteConfig = setTimeout(() => {
      getSiteStatus();
    }, 10000);

    return () => clearTimeout(checkSiteConfig);
  }, [siteStatus]);

  useEffect(() => {
    if (lang !== '') {
      if (pathname != '/' && pathname != '/reset' && !pathname.includes('/deal') && !pathname.includes('/status')) {
        setGreenScreen(false);
      }
      cookieUse();
    }
  }, [lang]);

  return (
    <Container className="App" maxWidth="lg">
      <UserDataContext.Provider value={{
        email: user.email,
        token: user.token,
        refCode: user.refCode,
        resetToken: user.resetToken,
        auth,
        deAuth,
        hasKyc: user.hasKyc,
        setHasKyc,
        lang,
        setLang,
        exchangeCount: siteStatus.exchangeCount,
        siteStatus: siteStatus.siteStatus
      }}
      >
        <Header lang={lang} setLang={setLang} />
        <GlobalModal />
        <RedirectToOrder />
        <GlobalModal />
        {(siteStatus.siteStatus === 1 || siteStatus.siteStatus === 2) &&
          <TechBreak
            mode={siteStatus.siteStatus}
            breakText={siteStatus.breakText}
            workTimeout={siteStatus.workTimeout}
            setGreenScreen={setGreenScreen}
          />
        }

        {siteStatus.siteStatus === 10 &&
          <Routes>
            <Route exact path="/" element={<Home greenScreen={greenScreen} setGreenScreen={setGreenScreen} urlData={siteStatus.urlData} />} />
            <Route exact path="/reset" element={<Home greenScreen={greenScreen} setGreenScreen={setGreenScreen} urlData={siteStatus.urlData} />} />
            <Route exact path="/deal/:tradeParams" element={<Home greenScreen={greenScreen} setGreenScreen={setGreenScreen} urlData={siteStatus.urlData} />} />
            <Route exact path="/account/*" element={user.token ? <Account /> : <Navigate to="/" />} />
            <Route exact path="/auth" element={<ExternalAuth />} />
            <Route exact path="/kyc-pass" element={<CommonKYC />} />
            <Route exact path="/status/:orderHash" element={<PerformOrder setGreenScreen={setGreenScreen} />} />
            <Route exact path="/404" element={<NotFound />} />
            <Route exact path="/rules" element={<Rules />} />
            <Route exact path="/rules/:page" element={<Rules />} />
            <Route exact path="/break" element={<TechBreak />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        }
        <Footer />
      </UserDataContext.Provider>
      {greenScreen && <MyGreenScreen><Logo /></MyGreenScreen>}
    </Container>
  );
}

export default withCookies(App);
